import CompanyDetailPage from "../features/crm/CompanyDetailPage";

export default function CompanyDetailRoute() {
  return <CompanyDetailPage />;
}
